import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=5b2fbbb4&scoped=true&"
import script from "./refund.vue?vue&type=script&lang=js&"
export * from "./refund.vue?vue&type=script&lang=js&"
import style0 from "./refund.vue?vue&type=style&index=0&id=5b2fbbb4&scoped=true&lang=css&"
import style1 from "./refund.vue?vue&type=style&index=1&id=5b2fbbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2fbbb4",
  null
  
)

export default component.exports